import { render, staticRenderFns } from "./BalanceHeaderSet.vue?vue&type=template&id=505398ef&scoped=true&"
import script from "./BalanceHeaderSet.vue?vue&type=script&lang=ts&"
export * from "./BalanceHeaderSet.vue?vue&type=script&lang=ts&"
import style0 from "./BalanceHeaderSet.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BalanceHeaderSet.vue?vue&type=style&index=1&id=505398ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505398ef",
  null
  
)

export default component.exports